import React from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { optionsEstadosSelect } from "src/data/ConstantForm";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import { useDispatch } from "react-redux";
import { GlobalConstants } from "src/data/GlobalConstants";
import SelectFormVirtualize from "src/components/ComponentesFormularios/SelectFormVirtualize";
import { modalCRUDService } from "src/services/modalCRUDService";
import { dateToStringFormat, getFechaToCalendarRange } from "src/util/functions";
import { CalendarFormRange } from "src/components/ComponentesFormularios/CalendarForm";
import { promocionesService } from "src/services/unoauno/apiPromociones";

const PROMOCIONESTIPOS = [
    { id: 1, text: 'Producto X Producto' },
    { id: 2, text: 'Producto X Cantidad' },
    { id: 3, text: 'Producto X Frecuencia' },
    // { id: 4, text: 'Descuento' },
    { id: 5, text: 'Visualizar en la App' },
]

const FormCrudPromociones = ({properties}) => {
    const dispatch = useDispatch();

    const { data: { 
        proveedor,
        dataProm,
        segmentaciones,
        productos,
        edit,
        reload
    } } = properties;

    const methods = useForm({ defaultValues: {
        nombre: edit ? dataProm.titulo : '',
        tipoPromocion: edit ? PROMOCIONESTIPOS.find(el => el.id == dataProm.tipo) : PROMOCIONESTIPOS[0],
        fecha: edit ? getFechaToCalendarRange(dataProm.fechaInicio, dataProm.fechaFin) : [new Date(), new Date()],
        productosSelected: edit ? JSON.parse(dataProm.pDescuento || "[]") : [],
        asignaciones: edit ? dataProm.asignaciones : [],
        estado: edit ? optionsEstadosSelect.find(el => el.id == dataProm.estado) : optionsEstadosSelect[0],
        cantidad: edit ? dataProm.cantidadCumplir : 0,
        frecuencia: edit ? dataProm.frecuenciaMes : 0,
        productoRegalo: edit ? dataProm.idProducto : null,
        productoCondicion: edit ? dataProm.idProductoCumplir : null
    }});
    const { control, setValue, handleSubmit, getValues, formState: { errors } } = methods;

    const changeTipo = useWatch({ control, name: 'tipoPromocion' });
    const productsSelected = useWatch({ control, name: 'productosSelected' });
    const asignaciones = useWatch({ control, name: 'asignaciones' });

    const onClickGuardar = async (data) => {
        if(asignaciones.length == 0) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes agregar al menos una segmentación' } });
            return;
        }

        const dataSave = {}

        switch (changeTipo.id) {
            case 1:
                const productoRegalo = getValues('productoRegalo');
                const productoCondicion = getValues('productoCondicion');

                if(productoRegalo == null || productoRegalo == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un producto de regalo' } });
                    return;
                }

                if(productoCondicion == null || productoCondicion == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un producto condición' } });
                    return;
                }

                dataSave.productoRegalo = productoRegalo.id;
                dataSave.productoCondicion = productoCondicion.id;
                break;
            case 2:
                const cantidad = getValues('cantidad');
                const productoRegalo2 = getValues('productoRegalo');

                if(productoRegalo2 == null || productoRegalo2 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un producto de regalo' } });
                    return;
                }

                if(cantidad == "" || cantidad <= 0) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes ingresar una cantidad y tiene que ser mayor a 0' } });
                    return;
                }

                dataSave.cantidad = cantidad;
                dataSave.productoRegalo = productoRegalo2.id;
                break;
            case 3:
                const frecuencia = getValues('frecuencia');
                const productoRegalo3 = getValues('productoRegalo');

                if(productoRegalo3 == null || productoRegalo3 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un producto de regalo' } });
                    return;
                }

                if(frecuencia == "" || frecuencia <= 0) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes ingresar una frecuencia y tiene que ser mayor a 0' } });
                    return;
                }

                dataSave.frecuencia = frecuencia;
                dataSave.productoRegalo = productoRegalo3.id;
                break;
            case 4:
                break;
            case 5:
                const products = getValues('productosSelected');
                if(products.length == 0) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar al menos un producto' } });
                    return;
                }

                dataSave.productosSelected = JSON.stringify(products);
                break;
            default:
                break;
        }

        dataSave.idProm = dataProm.idProm;
        dataSave.idProveedor = proveedor;
        dataSave.nombre = data.nombre;
        dataSave.tipo = data.tipoPromocion.id;
        dataSave.fechaInicio = dateToStringFormat(data.fecha[0]);
        dataSave.fechaFin = dateToStringFormat(data.fecha[1]);
        dataSave.asignaciones = data.asignaciones;
        dataSave.estado = data.estado.id;
        dataSave.fechaCreacion = new Date().toISOString().split('T')[0];

        try {
            if(edit) {
                await promocionesService.updatePromocion({dataProm: dataSave});
            }else {
                await promocionesService.savePromocion({dataProm: dataSave});
            }

            reload();
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            console.log(error);
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ya existe una promoción con el mismo nombre' } });
        }
    }

    const addProduct = () => {
        const product = getValues('producto');
        if(!product) return;

        if(!productsSelected.some(pro => pro == product.id)) {
            setValue('productosSelected', [...productsSelected, product.id]);
            setValue('producto', null);    
        }else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'El producto ya se encuentra asignado' } });
        }
    }

    const deleteProduct = (id) => !edit && setValue('productosSelected', productsSelected.filter(asg => asg != id));

    const addAsignacion = () => {
        const segmentacion = getValues('segmentacion');
        if(!segmentacion) return;

        if(!asignaciones.some(asg => asg == segmentacion.id)) {
            setValue('asignaciones', [...asignaciones, segmentacion.id]);
            setValue('segmentacion', null);
        }else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'La segmentación ya se encuentra asignada' } });
        }
    }

    const deleteAsignacion = (id) => !edit && setValue('asignaciones', asignaciones.filter(asg => asg != id));

    const getParametrosPromocion = (tipo) => {
        const id = tipo?.id ?? -1;
        
        switch (id) {
            case 1:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={edit}
                            showId={true}
                            identificador="productoCondicion"
                            label="Producto Condición"
                            options={productos}
                            required={false}
                            className="px-2 col-4"
                        />

                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={edit}
                            showId={true}
                            identificador="productoRegalo"
                            label="Producto Regalo"
                            options={productos}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 2:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <InputForm
                            inputProps={{ control }}
                            identificador="cantidad" 
                            label="Cantidad a comprar"
                            placeholder=""
                            type="number"
                            disabled={edit}
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />

                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={edit}
                            showId={true}
                            identificador="productoRegalo"
                            label="Producto Regalo"
                            options={productos}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 3:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <InputForm
                            inputProps={{ control }}
                            identificador="frecuencia" 
                            label="Frecuencia por mes"
                            placeholder=""
                            type="number"
                            disabled={edit}
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />

                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={edit}
                            showId={true}
                            identificador="productoRegalo"
                            label="Producto Regalo"
                            options={productos}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 5:
                return (
                    <div className="w-100 mt-3">
                        <div className="d-flex position-relative align-items-center">
                            <SelectFormVirtualize
                                isMulti={false}
                                inputProps={{ control }}
                                disabled={edit}
                                showId={true}
                                identificador="producto"
                                label="Productos"
                                options={productos}
                                required={false}
                                className="px-2 col-4"
                            />

                            <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px"}}>
                                <a onClick={addProduct} className="icon-container-actions d-flex">
                                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                                </a>
                            </Tooltip>
                        </div>

                        <div className="w-100 px-2 mt-2">
                            <strong>Productos asignados:</strong>

                            <div className="w-100 row m-0 p-0">
                                {productsSelected.length > 0 ? 
                                    productsSelected.map(( pro, index ) => 
                                        <div key={index} className="containerTag">
                                            <span>{pro}</span>
                                            <i className="fas fa-times" onClick={() => deleteProduct(pro)}/>
                                        </div>
                                    ): 
                                    <div className="px-2 mt-1">
                                        <p>No hay productos asignados</p>    
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="w-100 d-flex align-items-center justify-content-center row m-0 p-0 mt-2">
                        <span style={{fontSize: "13pt"}}>Selecciona un tipo de promoción</span>
                    </div>
                ); 
        }
    }

    const getNameSegmentaciones = (id) => {
        const segmentacion = segmentaciones.find(seg => seg.id == id);
        return "Segmentación_" + segmentacion?.text ?? '';
    }

    return (
        <FormProvider {...methods}>
            <div className="p-2">
                <Tooltip title="Agregar" aria-label="agregar" style={{position: "absolute", right: "3.5%", zIndex: 1}}>
                    <a onClick={handleSubmit(onClickGuardar, () => {})} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                    </a>
                </Tooltip>

                <div className="w-100 row m-0 px-2 d-flex position-relative">
                    <InputForm
                        inputProps={{ control }}
                        identificador="nombre" 
                        label="Nombre Promoción"
                        placeholder=""
                        required={true}
                        textUppercase={false}
                        className="px-2 col-3"
                        customError={errors.nombre ? "El campo no puede estar vacío" : null}
                    />
                    
                    <CalendarFormRange
                        inputProps={{ control }}
                        disabled={false}
                        identificador="fecha" 
                        label="Fecha de activación"
                        required={true}
                        className="w-auto mb-2"
                        customError={errors.fecha ? "El campo no puede estar vacío" : null}
                    />

                    <SelectFormVirtualize
                        isMulti={false}
                        inputProps={{ control }}
                        disabled={false}
                        showId={false}
                        identificador="estado"
                        label="Estado de Promoción"
                        options={optionsEstadosSelect}
                        required={true}
                        className="px-2 col-2"
                        customError={errors.estado ? "El campo no puede estar vacío" : null}
                    />
                </div>

                <div className="w-100 row m-0 mt-1 px-2 d-flex position-relative">
                    <SelectFormVirtualize
                        isMulti={false}
                        inputProps={{ control }}
                        disabled={edit}
                        showId={false}
                        identificador="tipoPromocion"
                        label="Tipo de Promoción"
                        options={PROMOCIONESTIPOS}
                        required={true}
                        className="px-2 col-3"
                        customError={errors.tipoPromocion ? "Selecciona un campo" : null}
                    />
                </div>

                <div className="px-3 mt-4 pb-3 pt-1">
                    <div className="pt-2" style={{borderTop: "0.5px solid #D2D2D2"}}>
                        <strong style={{fontSize: "14pt"}}>Parametros de promoción:</strong>
                        {getParametrosPromocion(changeTipo)}
                    </div>
                </div>

                <div className="px-3 mt-4 pt-1">
                    <div className="pt-2 px-2" style={{borderTop: "0.5px solid #D2D2D2"}}>
                        <strong style={{fontSize: "14pt"}}>Segmentaciones Asignadas:</strong>

                        <div className="d-flex align-items-center mt-3">
                            <SelectFormVirtualize
                                isMulti={false}
                                inputProps={{ control }}
                                disabled={edit}
                                showId={false}
                                identificador="segmentacion"
                                label="Segmentaciones"
                                options={segmentaciones}
                                required={false}
                                className="px-2 col-4"
                            />

                            <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px"}}>
                                <a onClick={addAsignacion} className="icon-container-actions d-flex">
                                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                                </a>
                            </Tooltip>
                        </div>

                        <div className="p-2">
                            {asignaciones.length > 0 ? 
                                asignaciones.map(( asignacion, index ) => 
                                    <div key={index} className="w-100 row m-0 p-0 pl-4 d-flex align-items-center" style={{height: "40px"}}>
                                        <span className="d-block mb-1" key={index}>
                                            <strong style={{fontSize: "16px", fontWeight: "bold", marginBottom: "5px"}}>»</strong>&nbsp;&nbsp;{getNameSegmentaciones(asignacion)}
                                        </span>

                                        <Tooltip title="Eliminar" aria-label="eliminar" style={{marginLeft: "20px"}}>
                                            <a onClick={() => deleteAsignacion(asignacion)} className="icon-container-actions d-flex">
                                                <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                                                <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-trash fa-2x"/>
                                            </a>
                                        </Tooltip>
                                    </div>
                                )
                                : 
                                <div className="ml-5">
                                    <p>No hay segmentaciones asignadas</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </FormProvider>
    )
}

export default FormCrudPromociones